<script>
    import * as Functions from '../Functions';
    /*
     |
     | DATATABLES PROVIDES REACTIVE TABLES WITH SORTING AND FILTERING USING VUE.JS
     |
     |
     */

    // component renders table items
    export default {
        template: '#table-items',
        props: [ 'columns', 'default_sort_order', 'default_sort_key', 'current_route', 'default_checked', 'default_selected', 'fixed_table', 'update_permission', 'translations', 'primary_key' ],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
            if (typeof this.fixed_table === 'undefined' || this.fixed_table) {
                window.addEventListener('scroll', this.lockTableHead);
                this.makePseudoTableHead();
            }

            this.initialSetSelectedItems();
            this.$root.$emit('mounted:table-items');
            this.$nextTick(function () {
                this.getData(this.sort_key);
            });
        },
        data: function () {
            let sortOrders = {};
            this.columns.forEach(function (key) {
                sortOrders[key.code] = 'asc';
            }, this);

            // if exists default sort order, when set it to default order
            if(this.default_sort_order) {
                sortOrders[this.default_sort_key] = this.default_sort_order;
            }

            let checked = this.default_checked || [];

            return {
                primary: this.primary_key || 'id',
                sort_order: sortOrders,
                sort_key: this.default_sort_key,
                table: [],
                all_selected: false,
                checked: checked,
                page: 1,
                items_per_page: 50,
                domains: [],
                date_start: null,
                date_finish: null,
                search_string: null,
                where_filters: null,
                filters: null,
                selected_items: {},
            };
        },
        methods: {
            // sort by using ajax
            sortBy: function (key) {
                this.sort_order[key] = (this.sort_order[key] === 'asc') ? 'desc' : 'asc';
                this.sort_key = key;
                this.getData(key);
            },
            // get data using Ajax
            getData: function (key, pageNumber = 1) {
                let search_string = this.search_string || '';
                let where_filters = this.where_filters || '';
                let filters = this.filters || '';
                let date_start = this.date_start ? '&date_start=' + this.date_start : '';
                let date_finish = this.date_finish ? '&date_finish=' + this.date_finish : '';

                this.$http.get(this.current_route + '/data'
                    + '?page=' + pageNumber
                    + '&per_page=' + this.items_per_page
                    + '&sort_by=' + this.sort_key
                    + '&sort_order=' + this.sort_order[key]
                    + '&filter_by_domain=' + this.domains.join('|')
                    + '&search_string=' + encodeURIComponent(search_string)
                    + date_start
                    + date_finish
                    + where_filters
                    + filters
                ).then(function (response) {
                    this.table = response.data;
                }, function (response) {
                    console.log(response);
                });
            },
            // ajax removing method
            remove: function (key, $url) {
                if (confirm('Вы уверены что хотите удалить элемент?')) {
                    $url = $url || this.current_route + '/' + key;
                    this.$http.delete(
                        $url,
                        function (data, status, request) {
                            this.getData(this.sort_key, this.page);
                        }).error(function (data, status, request) {
                           alert(data.message);
                    })
                }
            },
            turn_off: function (key) {
                let url = this.current_route + '/' + key + '/deactivate';
                this.$http.post(
                    url,
                    function () {
                        this.getData(this.sort_key, this.page);
                    }).error(function (response) {
                    console.log(response);
                });
            },
            turn_on: function (key) {
                let url = this.current_route + '/' + key + '/activate';
                this.$http.post(
                    url,
                    function (response) {
                        this.getData(this.sort_key, this.page);
                    }).error(function (response) {
                    console.log(response);
                });
            },
            select_all: function () {
                this.checked = [];
                this.selected_items = {};

                if (!this.all_selected) {
                    let items = this.table.data;
                    this.select_items(items);
                }
            },
            select_range: function (current) {
                let last = this.checked[this.checked.length - 1];
                if (!last) {
                    return;
                }

                let lastIndex = this.table.data.findIndex((item) => {return item.id === last});
                let currentIndex = this.table.data.findIndex((item) => {return item.id === current});
                if (lastIndex === currentIndex) {
                    return;
                }

                let items = lastIndex < currentIndex
                    ? this.table.data.slice(lastIndex + 1, currentIndex + 1)
                    : this.table.data.slice(currentIndex, lastIndex);

                this.select_items(items);
            },
            select_items: function (items) {
                let newChecked = Array.from(this.checked);

                for (let item in items) {
                    let value = items[item][this.primary];

                    if (newChecked.indexOf(value) === -1) {
                        newChecked.push(value);
                    }
                }

                this.checked = newChecked;
            },
            initialSetSelectedItems: function () {
                let selectedItems = {};
                let defaultSelected = this.default_selected || [];

                for (let i = 0; i < defaultSelected.length; i++) {
                    selectedItems[defaultSelected[i][this.primary]] = defaultSelected[i];
                }

                this.selected_items = selectedItems;
            },
            updateSelectedItems: function (newValues, oldValues) {
                // Added
                let added = Functions.array_diff(newValues, oldValues);
                for (let i = 0; i < added.length; i++) {
                    let item = this.table.data.find((function (tableItem) {
                        return tableItem[this.primary] === added[i];
                    }).bind(this));

                    Vue.set(this.selected_items, item[this.primary], item);
                }

                // Deleted
                let deleted = Functions.array_diff(oldValues, newValues);
                for (let i = 0; i < deleted.length; i++) {
                    Vue.delete(this.selected_items, deleted[i]);
                }

                this.$root.$emit('update:selected_items', this.selected_items);
            },
            makePseudoTableHead: function () {
                let table = this.getElByClassName('b-admin-table');
                let pseudoHead = table.getElementsByTagName('thead')[0].cloneNode(true);
                pseudoHead.classList.add('b-admin-table__head_static', 'hidden');
                table.prepend(pseudoHead);

                let head = table.getElementsByTagName('thead')[1];
                head.classList.add('b-admin-table__head_will_fixed');
            },
            lockTableHead: function () {
                let table = this.getElByClassName('b-admin-table');
                let tableTopOffset = table.getBoundingClientRect().top + pageYOffset;
                let windowTopOffset = window.pageYOffset;

                this.checkOffset(windowTopOffset, tableTopOffset);
            },
            checkOffset: function (windowTopOffset, tableTopOffset) {
                if (windowTopOffset >= tableTopOffset) {
                    this.fixTableHead();
                } else {
                    this.unFixTableHead();
                }
            },
            fixTableHead: function () {
                this.getElByClassName('b-admin-table__head_will_fixed').classList.add('b-admin-table__head_fixed');
                this.getElByClassName('b-admin-table__head_static').classList.remove('hidden');
            },
            unFixTableHead: function () {
                this.getElByClassName('b-admin-table__head_will_fixed').classList.remove('b-admin-table__head_fixed');
                this.getElByClassName('b-admin-table__head_static').classList.add('hidden');
            },
            getElByClassName: function (el) {
                return document.getElementsByClassName(el)[0];
            },
            updateTableEventHandler: function (data) {
                if (data && data.page) {
                    this.page = data.page;
                }
                if (data && data.search_string !== undefined) {
                    this.search_string = data.search_string;
                }
                if (data && data.where_conditions !== undefined) {
                    this.where_filters = this.buildWhereFilters(data.where_conditions);
                }
                if (data && data.conditions !== undefined) {
                    this.filters = this.buildFilters(data.conditions);
                }

                this.all_selected = false;

                this.getData(this.sort_key, this.page);
            },
            buildWhereFilters : function(where_conditions) {
                let resultQuery = '';
                for (let [fieldName,condition] of Object.entries(where_conditions)) {
                    resultQuery += `&where_fields[${fieldName}][operator]=${condition.operator || '='}`;
                    resultQuery += `&where_fields[${fieldName}][value]=${condition.value}`;
                }

                return resultQuery;
            },
            buildFilters : function(conditions) {
                let resultQuery = '';
                for (let [fieldName,condition] of Object.entries(conditions)) {
                    if (condition !== null) {
                        resultQuery += `&${fieldName}=${condition}`;
                    }
                }

                return resultQuery;
            },
        },
        //EVENTS
        created: function () {
            this.$root.$on('update-table', this.updateTableEventHandler);
            this.$root.$on('clear-search', () => this.search_string = null);
            this.$root.$on('update:page', (val) => { this.page = val; this.getData(this.sort_key, this.page); });
            this.$root.$on('update:items_per_page', (val) => { this.items_per_page = val; this.getData(this.sort_key, this.page); });
            this.$root.$on('update:domains', (val) => { this.domains = val; this.getData(this.sort_key, this.page); });
            this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; this.getData(this.sort_key, this.page); });
            this.$root.$on('unselect-checked', () => {  this.checked = [];});
        },
        watch : {
            'table': function (val) {
                this.$root.$emit('update:table', val);
            },
            'checked': function (newChecked, oldChecked) {
                this.$root.$emit('update:checked', newChecked);

                this.updateSelectedItems(newChecked, oldChecked);
            },
        }
    };
</script>
